(function(){
  if('scrollRestoration' in history){ history.scrollRestoration='manual'; window.scrollTo(0,0); }
  var track=document.getElementById('scTrack'); if(!track) return;
  var scene=document.getElementById('scScene'), cap=document.getElementById('scCap'),
      body=document.getElementById('scBody'), capLabel=document.getElementById('scCapLabel'),
      quality=document.getElementById('scQuality'),
      scSub=document.querySelector('.scrolly-head .section-sub'),
      ings=[].slice.call(document.querySelectorAll('.sc-ing'));
  var TT=[], mobileMode=false;
  var TH=[[-255,-295],[255,-295],[-375,-165],[375,-165],[-430,-15],[430,-15],[-375,135],[375,135],[-262,262],[262,262]];
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mouth={x:0,y:0}, scale=1, capRise=300, liftMax=130, completed=false, collapsed=false, lastP=-1, lastY=window.scrollY;
  function ease(t){return t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2}
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function measure(){
    var hd=document.querySelector('header');
    var head=document.querySelector('.scrolly-head');
    if(hd&&head) head.style.paddingTop=(hd.offsetHeight+14)+'px';
    body.style.height=''; cap.style.height='';
    var s=scene.getBoundingClientRect(), b=body.getBoundingClientRect();
    scale=Math.min(1,s.width/1150);
    mobileMode = s.width < 700;
    if(!mobileMode){
      // Height-aware pass: top chips rest 295*scale above the bottle mouth, but
      // scale only tracks width. On short windows shrink the bottle first (which
      // raises the mouth), then tighten the halo, so the ring never climbs into
      // the headline.
      var mouthY=b.top-s.top+b.height*0.04;
      var need=295*scale+16;
      if(mouthY<need && b.height>260){
        var shrink=Math.min((need-mouthY)/0.96, b.height-260);
        body.style.height=(b.height-shrink)+'px';
        cap.style.height=(b.height-shrink)+'px';
        b=body.getBoundingClientRect();
        mouthY=b.top-s.top+b.height*0.04;
      }
      if(mouthY<need) scale=Math.max(0.55,(mouthY-16)/295);
    }
    mouth.x=b.left+b.width/2-s.left; mouth.y=b.top-s.top+b.height*0.04;
    // Cap-flight and finale-lift ceilings: vertical excursions may never cross
    // the scene top (the headline sits directly above it).
    var bodyTop=mouth.y-b.height*0.04;
    capRise=mobileMode?300*scale:Math.min(300*scale, Math.max(60, bodyTop-6));
    liftMax=mobileMode?26:Math.min(130*scale, Math.max(0, bodyTop-10));
    scene.classList.toggle('sc-tight', scale<0.62);
    ings.forEach(function(el){el.style.left=mouth.x+'px'; el.style.top=mouth.y+'px';});
    capLabel.style.top=(mouth.y-46)+'px';
    if(mobileMode){
      // MOBILE ONLY: 5-4-1 funnel pointing down into the bottle (BioPerine tip)
      var titleEl=document.querySelector('.scrolly-head .section-title');
      var titleB=titleEl?titleEl.getBoundingClientRect().bottom:0;
      var headroom=Math.max(250,(b.top-titleB)-24);
      var d=Math.min(66,s.width*0.176);
      var Y1=headroom*0.88, Y2=headroom*0.56, Y3=headroom*0.24;
      TT=[[-2*d,-Y1],[-d,-Y1],[0,-Y1],[d,-Y1],[2*d,-Y1],
          [-1.5*d,-Y2],[-0.5*d,-Y2],[0.5*d,-Y2],[1.5*d,-Y2],
          [0,-Y3]];
    } else {
      // DESKTOP: approved horseshoe halo around the bottle
      TT=TH.map(function(p){return [p[0]*scale, p[1]*scale];});
      // Hard floor: no chip — even at the top of its entry arc — may cross the
      // scene top. Arc peaks add up to 100*scale above the resting spot.
      var minTy=(10-mouth.y)+100*scale;
      TT.forEach(function(p){ if(p[1]<minTy) p[1]=minTy; });
    }
    lastP=-1;
  }
  function draw(p){
    var pc=ease(clamp(p/0.20,0,1));
    var rq=ease(clamp((p-0.86)/0.10,0,1));                 // cap flies back on
    var lift=liftMax*ease(clamp((p-0.88)/0.12,0,1));
    var f=(rq>0)?(1-rq):pc;                                 // cap flight fraction
    cap.style.transform='translateX(calc(-50% + '+(f*150*scale)+'px)) translateY('+(-f*capRise-lift)+'px) rotate('+(f*-170)+'deg)';
    cap.style.opacity=rq>0?String(Math.min(1,rq*2.5)):(pc<0.82?1:String(1-(pc-0.82)/0.18));
    body.style.transform='translateX(-50%) translateY('+(-lift)+'px)';
    capLabel.style.opacity=p<0.02?1:0;
    capLabel.style.transform='translateX(-50%)';
    quality.style.opacity=p>0.9?1:0;
    if(scSub) scSub.style.opacity=p>0.15?0:1;
    ings.forEach(function(el,i){
      var start=0.14+i*0.055, q=ease(clamp((p-start)/0.22,0,1));
      if(q<=0){el.style.opacity=0;return}
      var tx=TT[i][0], ty=TT[i][1];
      var arc=mobileMode?55:100*scale;
      var x=tx*q, y=ty*q-arc*Math.sin(Math.PI*q);
      el.style.opacity=Math.min(1,q*3);
      el.style.transform='translate('+x+'px, '+y+'px) rotate('+((i%2?-1:1)*(1-q)*25)+'deg) scale('+(0.35+0.65*q)+')';
    });
  }
  function render(){
    var r=track.getBoundingClientRect();
    var curY=window.scrollY;
    if(completed){
      if(!collapsed){
        if(curY < lastY - 4 && r.top < -2 && r.bottom > window.innerHeight){
          // User reversed upward inside the finished section: collapse NOW and
          // pin to the track top. Frozen sticky frame is identical => invisible.
          var docTop=window.scrollY + r.top;
          track.classList.add('sc-done'); collapsed=true;
          window.scrollTo({top: docTop, left: 0, behavior: 'instant'});
        } else if(r.bottom < -80){
          // Section fully above the viewport: collapse + compensate in one frame.
          // Nothing on screen belongs to the track, so this is pixel-invisible.
          var prevH=track.offsetHeight;
          track.classList.add('sc-done'); collapsed=true;
          window.scrollTo({top: window.scrollY-(prevH-track.offsetHeight), left: 0, behavior: 'instant'});
        } else if(r.top >= -2){
          // User climbed back to the track's top edge: height removed is entirely
          // below the viewport fold — no compensation needed, zero movement.
          track.classList.add('sc-done'); collapsed=true;
        }
      } else if(r.top > window.innerHeight*1.6){
        // Far below the viewport: quietly re-arm for the next descent.
        completed=false; collapsed=false; track.classList.remove('sc-done'); lastP=-1;
      }
      if(lastP!==1){lastP=1; draw(1);}
      lastY=window.scrollY;
      requestAnimationFrame(render); return;
    }
    var p=clamp(-r.top/(r.height-window.innerHeight),0,1);
    if(reduced) p=1;
    if(p!==lastP){ lastP=p; draw(p); }
    if(p>=0.999) completed=true;   // note: NO layout change at the completion moment
    lastY=window.scrollY;
    requestAnimationFrame(render);
  }
  window.addEventListener('resize',measure);
  if(body.complete){measure()}else{body.onload=measure}
  requestAnimationFrame(render);
})();
